var map = {
	"./tab4/tab4.module": [
		"./src/app/tab4/tab4.module.ts",
		"tab4-tab4-module"
	],
	"./tab5/tab5.module": [
		"./src/app/tab5/tab5.module.ts",
		"tab5-tab5-module"
	],
	"./tab6/tab6.module": [
		"./src/app/tab6/tab6.module.ts",
		"tab6-tab6-module"
	],
	"./tab7/tab7.module": [
		"./src/app/tab7/tab7.module.ts",
		"tab7-tab7-module"
	],
	"./tab8/tab8.module": [
		"./src/app/tab8/tab8.module.ts",
		"tab8-tab8-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;